const Common ={
    // urlAPI: "https://intranetdev.upn.edu.pe/WSPagosOnline",
    urlAPI:`${process.env.REACT_APP_urlAPI}`,
    urlAPISeguridad: `${process.env.REACT_APP_urlAPISeguridad}`,
    urlAPISession:`${process.env.REACT_APP_urlAPISession}`,
    urlFormulario:`${process.env.REACT_APP_urlFormulario}`,
    // urlAPIPayment:"https://intranetdes.upn.edu.pe/wsmooestro",
    urlConfirmar:`${process.env.REACT_APP_urlConfirmar}`,
    urlVolver:`${process.env.REACT_APP_urlVolver}`,
    CERTIFIKATE_URL:`${process.env.REACT_APP_CERTIFIKATE_URL}`,
    URLMooestroPortalAlumnos:`${process.env.REACT_APP_URLMooestroPortalAlumnos}`,
    PORTAL_TRAMITES_UPN_URL:`${process.env.REACT_APP_PORTAL_TRAMITES_UPN_URL}`,
    merchandId:`${process.env.REACT_APP_MERCHANT_ID}`
}
export default Common;